import { ArrowDownIcon, ArrowUpIcon, Button } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import type { FC } from 'react'
import React from 'react'

type Props = {
  onClick(): void
  showingMore?: boolean
}

export const ShowMore: FC<Props> = ({ onClick, showingMore }) => {
  const { t } = usePlanningFormTranslation()

  return (
    <Button
      rightIcon={showingMore ? <ArrowUpIcon /> : <ArrowDownIcon />}
      onClick={onClick}
      intent='default'
      variant='tertiary'
      size='s'
      className='w-fit self-end'
    >
      {t('component.showMore.title')}
    </Button>
  )
}
